import type { AuthResponse, LoginInput, PublicUser, SignupInput } from '@bcl/shared';
import { api } from '@/lib/api';

export async function signup(input: SignupInput): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/signup', input);
  return data;
}

export async function login(input: LoginInput): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/login', input);
  return data;
}

export async function fetchMe(): Promise<PublicUser> {
  const { data } = await api.get<PublicUser>('/auth/me');
  return data;
}
